import React from 'react';

export const TwitterWhiteCircleSvg = () => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-979, -20)" fill="#FFFFFF" fillRule="nonzero">
        <path d="M999,20 C1010.04569,20 1019,28.954305 1019,40 C1019,51.045695 1010.04569,60 999,60 C987.954305,60 979,51.045695 979,40 C979,28.954305 987.954305,20 999,20 Z M995.056,30.25 L988.23,30.25 L996.386,40.915 L988.656,49.75 L991.966,49.75 L997.932,42.933 L1003.146,49.75 L1009.803,49.75 L1001.301,38.51 L1008.528,30.25 L1005.22,30.25 L999.769,36.481 L995.056,30.25 Z M994.06,32.126 L1005.892,47.77 L1004.059,47.77 L992.093,32.126 L994.06,32.126 Z" />
      </g>
    </g>
  </svg>
);
